"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMobileViewport = exports.currentLayoutWidth = exports.layoutWidth = exports.breakPoint = exports.layoutWidthMap = exports.breakPointMap = exports.sizes = exports.space = void 0;
var helpers_1 = require("./helpers");
var browser_1 = require("./browser");
var base = 0.5;
var space = function (size) {
    if (size === void 0) { size = 1; }
    return (0, helpers_1.rem)(size, base);
};
exports.space = space;
exports.sizes = ['xs', 'sm', 'md', 'lg', 'xl'];
exports.breakPointMap = {
    // breakpoints, in px
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
};
exports.layoutWidthMap = {
    // widths at breakpoints, in px
    sm: 540,
    md: 720,
    lg: 960,
    xl: 1140,
};
var breakPoint = function (key) { return exports.breakPointMap[key]; };
exports.breakPoint = breakPoint;
var layoutWidth = function (key) { return exports.layoutWidthMap[key]; };
exports.layoutWidth = layoutWidth;
var currentLayoutWidth = function () {
    if (!(0, browser_1.isBrowser)())
        return exports.layoutWidthMap.lg;
    if (window.innerWidth >= exports.breakPointMap.xl)
        return exports.layoutWidthMap.xl;
    if (window.innerWidth >= exports.breakPointMap.lg)
        return exports.layoutWidthMap.lg;
    if (window.innerWidth >= exports.breakPointMap.md)
        return exports.layoutWidthMap.md;
    if (window.innerWidth >= exports.breakPointMap.sm)
        return exports.layoutWidthMap.sm;
    return window.innerWidth;
};
exports.currentLayoutWidth = currentLayoutWidth;
var isMobileViewport = function () {
    return (0, browser_1.isBrowser)() &&
        window.matchMedia("only screen and (max-width: ".concat((0, exports.breakPoint)('sm'), "px)"))
            .matches;
};
exports.isMobileViewport = isMobileViewport;
//# sourceMappingURL=layout.js.map